var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveFigureBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 303,
    height: 289,
    viewBox: "0 0 303 289",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2539 72.9978L8.46827 72.9978C12.9071 72.9978 16.5055 69.3994 16.5055 64.9606L16.5055 10.0373C16.5055 5.5984 20.1039 2 24.5428 2L293.563 2.00001C298.002 2.00001 301.6 5.59841 301.6 10.0373L301.6 278.963C301.6 283.402 298.002 287 293.563 287L24.5428 287C20.1039 287 16.5055 283.402 16.5055 278.963L16.5055 218.855C16.5055 214.416 12.9071 210.817 8.46827 210.817L1.2539 210.817",
    stroke: "#333333",
    strokeWidth: 2.41118,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveFigureBorder);
export default __webpack_public_path__ + "static/media/moveFigureBorder.07b21fc22e0924ea57a143ae0fc1895c.svg";
export { ForwardRef as ReactComponent };